import Api from '../api';

const { axios: api } = Api;
const PREFIX = 'mail';

export const reportMailClick = async (payload) => {
	const { data } = await api.post(`/${PREFIX}/click`, payload);
	return data;
};
